const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

let countDown = new Date('2025-12-02T07:00:00Z').getTime(),
    x = setInterval(function() {

      let now = new Date().getTime(),
          distance = countDown - now;

      document.getElementById('days').innerText = Math.floor(distance / (day)),
        document.getElementById('hours').innerText = Math.floor((distance % (day)) / (hour)),
        document.getElementById('minutes').innerText = Math.floor((distance % (hour)) / (minute)),
        document.getElementById('seconds').innerText = Math.floor((distance % (minute)) / second);
      

    }, second)


//FRIDAY 
//2019-11-30T16:00:00Z

//SATURDAY
//2019-12-01T16:00:00Z

//SUNDAY
//2019-12-02T16:00:00Z

//MONDAY
//2019-12-03T16:00:00Z

